export const toLowercase = <T extends string>(value: T): Lowercase<T> =>
	value.toLowerCase() as Lowercase<T>;
